import React from "react";
import { ErrorPage } from "./ErrorPage";

export interface ClientErrorPageProps {
  error?: Error | unknown;
}

export const ClientErrorPage: React.FC<ClientErrorPageProps> = ({ error }) => {
  // Extract first line of error message
  const errorMessage = error instanceof Error ? error.message.split('\n')[0] : "An unexpected error occurred";

  return (
    <ErrorPage
      title="Client Error"
      heading="We're sorry, something went wrong"
      body={errorMessage}
      metaTitle="Client Error - Tennr"
      metaDescription="We're sorry, something went wrong."
    />
  );
};